import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import logo from "../../images/logo.svg";
import googleButton from "../../images/web_light_sq_SI@2x.png";
import "../landing/auth.css";
import "./student.css";

// Student sign-in. Students do NOT create their own record anymore — they sign in
// (managed Google account = the smooth path) and are matched to the roster entry
// their teacher already made (see shared/studentIdentity.js). Email/password stays
// as a fallback for anyone without a Google account.
const StudentLogIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [error, setError] = useState("");
  const auth = getAuth();
  const navigate = useNavigate();

  const handleGoogle = async () => {
    setError("");
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
      navigate("/student-dashboard");
    } catch (err) {
      console.error("Student Google sign-in failed:", err);
      setError("Sign-in didn't work. Ask your teacher for help.");
    }
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/student-dashboard");
    } catch (err) {
      console.error("Student sign-in failed:", err);
      setError("That email or password didn't work. Ask your teacher for help.");
    }
  };

  return (
    <div className="auth-card student-auth">
      <div className="auth-head">
        <img src={logo} className="auth-logo" alt="classBoon" />
        <h1 className="auth-title">Student sign-in</h1>
        <p className="auth-sub">Sign in to sign out, check in, and stay safe.</p>
      </div>

      <button onClick={handleGoogle} className="auth-google" type="button">
        <img src={googleButton} alt="Sign in with Google" />
      </button>

      {!showEmail ? (
        <button
          type="button"
          className="auth-linkbtn student-email-toggle"
          onClick={() => setShowEmail(true)}
        >
          Use an email and password instead
        </button>
      ) : (
        <form className="auth-form" onSubmit={handleEmail}>
          <div className="auth-divider">or</div>
          <div className="auth-field">
            <label htmlFor="stu-email">Email</label>
            <input
              id="stu-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@school.org"
            />
          </div>
          <div className="auth-field">
            <label htmlFor="stu-pass">Password</label>
            <input
              id="stu-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Password"
            />
          </div>
          <button type="submit" className="auth-submit">Sign in</button>
        </form>
      )}

      {error && <p className="auth-error">{error}</p>}

      <p className="auth-foot student-foot">
        Trouble signing in? Ask your teacher.
      </p>
      <p className="student-legal">
        By using classBoon you agree to our{" "}
        <a href="https://classboon.com/terms" target="_blank" rel="noopener noreferrer">Terms</a>{" "}
        and{" "}
        <a href="https://classboon.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>
    </div>
  );
};

export default StudentLogIn;
